
import "./FileUploader.css";

import React, { useRef, useState } from "react";

import { useTranslation } from "react-i18next";

import { vector } from "../../_config/layers";

import CSVUploader from "./components/CSVUploader/CSVUploader";
import KMLUploader from "./components/KMLUploader";
import ShapeUploader from "./components/ShapeUploader";

import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

function FileUploader(props) {
  const { t } = useTranslation();

  const htmlElement = useRef();

  const [active, setActive] = useState(false);

  const handleFileUploaderClick = () => {
    vector.getSource().clear();
    setActive(true);
  };

  const closeModal = () => {
    setActive(false);
  };

  return (
    <div id="FileUploader" className="FileUploader">
      <Button
        className="HorizontalButton"
        type="button"
        alt={t("fileUploader.title")}
        title={t("fileUploader.title")}
        onClick={handleFileUploaderClick}
        ref={htmlElement}
        icon="pi pi-upload"
      />

      <Dialog
        className="FileUploaderDialog"
        header={t("fileUploader.title")}
        visible={active}
        onHide={closeModal}
        modal
        dismissableMask
        closable
        appendTo={document.body}
        draggable={false}
        resizable={false}
        blockScroll
        style={{ width: "620px", maxWidth: "94vw" }}
      >
        <div className="FileUploaderBody">
          <CSVUploader
            map={props.map}
            callback={closeModal}
          />

          <ShapeUploader
            map={props.map}
            callback={closeModal}
          />

          <KMLUploader
            map={props.map}
            callback={closeModal}
          />
        </div>
      </Dialog>
    </div>
  );
}

export default FileUploader;

